"use client";

import { usePathname } from "next/navigation";
import Footer from "@/components/navigation/Footer";
import Navbar from "@/components/navigation/Navbar";
import NexHealthBookingButton from "@/components/tools/NexHealth";

interface ConditionalLayoutProps {
  children: React.ReactNode;
}

export default function ConditionalLayout({ children }: ConditionalLayoutProps) {
  const pathname = usePathname();
  
  // Hide navbar and footer for dashboard routes and google ads landing pages
  const isDashboard = pathname?.startsWith('/dashboard');
  const isGoogleAds = pathname?.startsWith('/google-ads');
  
  return (
    <>
      {!isDashboard && !isGoogleAds && <Navbar />}
      <main className="">
        {children}
      </main>
      {!isDashboard && !isGoogleAds && (
        <>
          <NexHealthBookingButton />
          <Footer />
        </>
      )}
    </>
  );
}
